import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { PolicyTypeEnum } from '../enums/policy-type.enum';

/**
 * Maps each subject to the policy types that can be assigned to it.
 */
export const POLICY_TYPES_BY_SUBJECT: Record<
  AppSubjectEnum,
  PolicyTypeEnum[] | undefined
> = {
  [AppSubjectEnum.ALL]: undefined,
  [AppSubjectEnum.PLATFORM_ALL]: undefined,
  [AppSubjectEnum.SYSTEM]: undefined,
  [AppSubjectEnum.SETTINGS]: undefined,
  [AppSubjectEnum.USER_SETTINGS]: undefined,
  [AppSubjectEnum.USER_APP_SETTINGS]: undefined,
  [AppSubjectEnum.APPEARANCE]: undefined,
  [AppSubjectEnum.POLICY]: undefined,
  [AppSubjectEnum.USER]: undefined,
  [AppSubjectEnum.FILE]: undefined,
  [AppSubjectEnum.TAG]: undefined,
  [AppSubjectEnum.AUDIT_LOG]: undefined,
  [AppSubjectEnum.CHANGE_LOG]: undefined,
  [AppSubjectEnum.CONTACT]: undefined,
  [AppSubjectEnum.DRIVER]: undefined,
  [AppSubjectEnum.CUSTOMER]: [
    PolicyTypeEnum.DRIVER_ELIGIBILITY,
    PolicyTypeEnum.RENTAL_DURATION,
    PolicyTypeEnum.MINIMUM_RENTAL,
    PolicyTypeEnum.DEPOSIT,
    PolicyTypeEnum.LATE_RETURN,
    PolicyTypeEnum.MILEAGE,
  ],
  [AppSubjectEnum.LOCATION]: [PolicyTypeEnum.WORKING_PERIODS],
  [AppSubjectEnum.SUPPLIER]: [
    PolicyTypeEnum.RENTAL_DURATION,
    PolicyTypeEnum.MINIMUM_RENTAL,
    PolicyTypeEnum.DEPOSIT,
    PolicyTypeEnum.LATE_RETURN,
    PolicyTypeEnum.MILEAGE,
  ],
  [AppSubjectEnum.AGENT]: [
    PolicyTypeEnum.RENTAL_DURATION,
    PolicyTypeEnum.MINIMUM_RENTAL,
    PolicyTypeEnum.DEPOSIT,
    PolicyTypeEnum.LATE_RETURN,
    PolicyTypeEnum.MILEAGE,
  ],
  [AppSubjectEnum.AGENT_CATEGORY]: [
    PolicyTypeEnum.RENTAL_DURATION,
    PolicyTypeEnum.MINIMUM_RENTAL,
    PolicyTypeEnum.DEPOSIT,
    PolicyTypeEnum.LATE_RETURN,
    PolicyTypeEnum.MILEAGE,
  ],
  [AppSubjectEnum.VEHICLE]: [
    PolicyTypeEnum.WORKING_PERIODS,
    PolicyTypeEnum.FUEL,
    PolicyTypeEnum.RENTAL_DURATION,
    PolicyTypeEnum.MINIMUM_RENTAL,
    PolicyTypeEnum.DRIVER_ELIGIBILITY,
    PolicyTypeEnum.DEPOSIT,
    PolicyTypeEnum.LATE_RETURN,
    PolicyTypeEnum.MILEAGE,
  ],
  [AppSubjectEnum.VEHICLE_FEATURE_ITEM]: undefined,
  [AppSubjectEnum.VEHICLE_FEATURE_ITEM_FILE]: undefined,
  [AppSubjectEnum.VEHICLE_GROUP]: undefined,
  [AppSubjectEnum.VEHICLE_CATEGORY]: [
    PolicyTypeEnum.WORKING_PERIODS,
    PolicyTypeEnum.FUEL,
    PolicyTypeEnum.RENTAL_DURATION,
    PolicyTypeEnum.MINIMUM_RENTAL,
    PolicyTypeEnum.DRIVER_ELIGIBILITY,
    PolicyTypeEnum.DEPOSIT,
    PolicyTypeEnum.LATE_RETURN,
    PolicyTypeEnum.MILEAGE,
  ],
  [AppSubjectEnum.VEHICLE_CATEGORY_FEATURE_ITEM]: undefined,
  [AppSubjectEnum.VEHICLE_CATEGORY_FEATURE_ITEM_FILE]: undefined,
  [AppSubjectEnum.VEHICLE_CATEGORY_PRICING_TIER_ITEM]: undefined,
  [AppSubjectEnum.VEHICLE_DAMAGE]: undefined,
  [AppSubjectEnum.VEHICLE_GPS_TRACKING]: undefined,
  [AppSubjectEnum.VEHICLE_INSURANCE]: undefined,
  [AppSubjectEnum.VEHICLE_INSURANCE_CLAIM]: undefined,
  [AppSubjectEnum.VEHICLE_MAINTENANCE]: undefined,
  [AppSubjectEnum.VEHICLE_ROAD_TAX]: undefined,
  [AppSubjectEnum.VEHICLE_ROAD_WORTHY_CHECK]: undefined,
  [AppSubjectEnum.VEHICLE_COLOR]: undefined,
  [AppSubjectEnum.VEHICLE_MAKE]: undefined,
  [AppSubjectEnum.VEHICLE_MODEL]: undefined,
  [AppSubjectEnum.RENTAL_AGREEMENT]: [
    PolicyTypeEnum.RENTAL_DURATION,
    PolicyTypeEnum.MINIMUM_RENTAL,
    PolicyTypeEnum.DRIVER_ELIGIBILITY,
    PolicyTypeEnum.DEPOSIT,
    PolicyTypeEnum.LATE_RETURN,
    PolicyTypeEnum.MILEAGE,
  ],
  [AppSubjectEnum.RENTAL_AGREEMENT_PARTY]: undefined,
  [AppSubjectEnum.RENTAL_AGREEMENT_PARTY_DRIVING_LICENSE]: undefined,
  [AppSubjectEnum.RENTAL_RESERVATION]: [
    PolicyTypeEnum.RENTAL_DURATION,
    PolicyTypeEnum.MINIMUM_RENTAL,
    PolicyTypeEnum.DRIVER_ELIGIBILITY,
    PolicyTypeEnum.DEPOSIT,
    PolicyTypeEnum.LATE_RETURN,
    PolicyTypeEnum.MILEAGE,
  ],
  [AppSubjectEnum.RENTAL_RESERVATION_PARTY]: undefined,
  [AppSubjectEnum.RENTAL_RESERVATION_PARTY_DRIVING_LICENSE]: undefined,
  [AppSubjectEnum.RENTAL_SNAPSHOT]: undefined,
  [AppSubjectEnum.AGREEMENT_CONTACT]: undefined,
  [AppSubjectEnum.TRANSACTION]: undefined,
  [AppSubjectEnum.PAYMENT]: undefined,
  [AppSubjectEnum.PAYMENT_ACTIVITY_TRACKING]: undefined,
  [AppSubjectEnum.FILE_LOG]: undefined,
  [AppSubjectEnum.NOTIFICATION_PREFERENCES]: undefined,
  [AppSubjectEnum.NOTIFICATION_LOG]: undefined,
  [AppSubjectEnum.REMINDER_PREFERENCES]: undefined,
  [AppSubjectEnum.REMINDER_LOG]: undefined,
  [AppSubjectEnum.PROTO_PREFERENCES]: undefined,
  [AppSubjectEnum.PROTO_LOG]: undefined,
  [AppSubjectEnum.REPORT]: undefined,
  [AppSubjectEnum.REPORT_TEMPLATE]: undefined,
  [AppSubjectEnum.REPORT_JOB]: undefined,
  [AppSubjectEnum.DATA_EXPORT_JOB]: undefined,
  [AppSubjectEnum.TENANT]: undefined,
  [AppSubjectEnum.TENANT_METADATA]: undefined,
  [AppSubjectEnum.INBOX]: undefined,
  [AppSubjectEnum.FILEBOX]: undefined,
  [AppSubjectEnum.OUTBOX]: undefined,
  [AppSubjectEnum.PLATFORM_SETTINGS]: undefined,
  [AppSubjectEnum.BILLABLE_EVENT]: undefined,
  [AppSubjectEnum.ADDON]: undefined,
  [AppSubjectEnum.STORAGE]: undefined,
  [AppSubjectEnum.ACCOUNT]: undefined,
  [AppSubjectEnum.ASSET]: undefined,
  [AppSubjectEnum.ASSET_FEATURE_ITEM]: undefined,
  [AppSubjectEnum.ASSET_PRICING_ITEM]: undefined,
  [AppSubjectEnum.ASSET_RESERVATION]: undefined,
  [AppSubjectEnum.TENANT_SETTINGS]: undefined,
};
